module.exports = __webpack_public_path__ + "img/lebanon.5fd641e4.svg";